module.exports = __webpack_public_path__ + "fonts/DINPro-BlackItalic.ac34cae9.otf";